export const CONTRACT_NAMES = ['dao-proposal-multiple']

export const PRE_PROPOSE_CONTRACT_NAMES = ['dao-pre-propose-multiple']
